// extracted by mini-css-extract-plugin
export default {"reply":"style--reply--37768f","label":"style--label--b6047b","textarea":"style--textarea--4c6f80","guidelines":"style--guidelines--6edabb"};